import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { routes } from '../../../../utils/routes'

const SettingsMenu: React.FC = () => {
  const location = useLocation()
  const path = location?.pathname

  return (
    <div className='col-lg-3'>
      <div className='card'>
        <div className='card-body'>
          <ul className='settings-menu'>
            <li>
              <Link
                to='/settings/company-profile'
                className={path == '/settings/company-profile' ? 'active' : ''}
              >
                Company Profile
              </Link>
            </li>
            <li>
              <Link
                to='/settings/layout'
                className={path == '/settings/layout' ? 'active' : ''}
              >
                Layout Settings
              </Link>{' '}
            </li>
            <li>
              <Link
                to={routes.customerTypesettings.path}
                className={
                  location.pathname === routes.customerTypesettings.path
                    ? 'active'
                    : ''
                }
              >
                Customer Type
              </Link>
            </li>
            <li>
              <Link
                to={routes.titleTypesettings.path}
                className={
                  location.pathname === routes.titleTypesettings.path
                    ? 'active'
                    : ''
                }
              >
                Title Type
              </Link>
            </li>
            <li>
              <Link
                to={routes.vesselTypesettings.path}
                className={
                  location.pathname === routes.vesselTypesettings.path
                    ? 'active'
                    : ''
                }
              >
                Vessel Type
              </Link>
            </li>
            <li>
              <Link
                to={routes.deliveryOptionsettings.path}
                className={
                  location.pathname === routes.deliveryOptionsettings.path
                    ? 'active'
                    : ''
                }
              >
                Delivery Options
              </Link>
            </li>
            <li>
              <Link
                to={routes.deliveryTermsettings.path}
                className={
                  location.pathname === routes.deliveryTermsettings.path
                    ? 'active'
                    : ''
                }
              >
                Delivery Terms
              </Link>
            </li>
            <li>
              <Link
                to={routes.paymentTermsettings.path}
                className={
                  location.pathname === routes.paymentTermsettings.path
                    ? 'active'
                    : ''
                }
              >
                Payment Terms
              </Link>
            </li>
            <li>
              <Link
                to={routes.mailTypesettings.path}
                className={
                  location.pathname === routes.mailTypesettings.path
                    ? 'active'
                    : ''
                }
              >
                Mail Settings
              </Link>
            </li>
            <li>
              <Link
                to={routes.vatTypesettings.path}
                className={
                  location.pathname === routes.vatTypesettings.path
                    ? 'active'
                    : ''
                }
              >
                VAT Settings
              </Link>
            </li>

            <li>
              <Link
                to={routes.roleSetting.path}
                className={
                  location.pathname === routes.roleSetting.path ? 'active' : ''
                }
              >
                Roles
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SettingsMenu
